import React from "react";
import { createClientMessage, createChatBotMessage } from "react-chatbot-kit";
import axiosInstance from "../utils/axiosInstance";

const ActionProvider = ({ setState, children }) => {
  /**
   * Handles User Greetings
   */
  const handleGreeting = () => {
    const message = createChatBotMessage(
      "Hello! Welcome to Acubot 😊. How can I assist you today?",
    );

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, message],
    }));
  };

  /**
   * Handles bot's responses and updates the state
   */
  const handleBotResponse = async (message) => {
    try {
      // Call the API
      const response = await axiosInstance.post(
        "/api/acubot/chat",
        { message },
        { timeout: 5000 },
      );

      const data = response.data?.data;
      let botReply = data?.reply;

      if (!botReply) {
        botReply =
          "I'm sorry, I didn't understand that. Can you please rephrase?";
      }

      // Create bot message
      const botMessage = createChatBotMessage(botReply, {
        widget: "menuButtonWidget",
      });

      // "Go to Menu" Button
      // const menuButton = createChatBotMessage("Other Options", {
      //   widget: "menuButtonWidget",
      // });

      // Update state with new messages
      setState((prev) => ({
        ...prev,
        messages: [...prev.messages, botMessage],
      }));
    } catch (error) {
      console.error("Error calling API:", error);

      const errorMessage = createChatBotMessage(
        "Oops! Something went wrong. Please try again later.",
        {
          widget: "menuButtonWidget",
        },
      );

      setState((prev) => ({
        ...prev,
        messages: [...prev.messages, errorMessage],
      }));
    }
  };

  const handleSuggestedQuestionClick = (question) => {
    const intentMessage = createClientMessage(question);

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, intentMessage],
    }));

    handleBotResponse(question);
  };

  /**
   * Reset chat and show main intents
   */
  const handleGoToMenu = () => {
    const intentMessage = createChatBotMessage("Choose one:", {
      widget: "intentsWidget",
    });

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, intentMessage],
    }));
  };

  const handleIntentSelection = (intent) => {
    let message;
    if (intent === "General Queries") {
      message = createChatBotMessage("Please write your queries");
      message = createChatBotMessage(
        "Please select an option below or type your question",
        {
          widget: "generalQueriesWidget",
        },
      );
    } else if (intent === "Buy/Renew Policy") {
      message = createChatBotMessage("Please choose a type of insurance:", {
        widget: "subIntentsWidget",
        payload: {
          subIntents: ["Car", "Bike", "GCV", "PCV", "Health", "Life", "Pet"],
          intent: intent,
        },
      });
    } else if (intent === "Claim") {
      message = createChatBotMessage("Please choose a type of insurance:", {
        widget: "subIntentsWidget",
        payload: {
          subIntents: ["Car", "Bike", "GCV", "PCV", "Health", "Life"],
          intent: intent,
        },
      });
    } else if (intent === "Talk to our agent") {
      message = createChatBotMessage(`You can talk to our agent on :`, {
        widget: "supportOptionsWidget",
        payload: {
          intent,
        },
      });
    } else {
      message = createChatBotMessage(`You selected: ${intent}`);
    }

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, createClientMessage(intent), message],
    }));
  };

  const handleSubIntentSelection = (subIntent, intent) => {
    console.log("intent", intent);
    let messages = [createClientMessage(subIntent)];

    if (intent === "Buy/Renew Policy") {
      messages.push(
        createChatBotMessage(
          "You can buy insurance online, and it is safe if purchased from our website.",
          {
            widget: "goToQuickQuoteOptionWidget",
            payload: {
              subIntent: subIntent,
              intent: intent,
            },
          },
        ),
      );
      messages.push(
        createChatBotMessage(
          "or contact our customer service for assistance.",
          {
            widget: "contactOptionsWidget",
            payload: {
              subIntent: subIntent,
              intent: intent,
            },
          },
        ),
      );
    } else if (intent === "Claim") {
      if (
        subIntent === "Car" ||
        subIntent === "Bike" ||
        subIntent === "GCV" ||
        subIntent === "PCV"
      ) {
        messages.push(
          createChatBotMessage("Here are the required documents:", {
            widget: "documentsWidget",
            payload: {
              title: "Required Documents for Motor Insurance Claim",
              documents: [
                "Copy of RC (Registration Certificate)",
                "Copy of driving license",
                "Insurance policy copy",
                "FIR (if required, e.g., major accidents)",
                "Repair estimate from the garage",
                "Photographs of vehicle damage",
              ],
            },
          }),
        );
      } else if (subIntent === "Health") {
        messages.push(
          createChatBotMessage("Here are the required documents:", {
            widget: "documentsWidget",
            payload: {
              title: "Required Documents for Health Insurance Claim",
              documents: [
                "Duly filled claim form (from the insurer)",
                "Policy copy (Health Card or Policy Document)",
                "ID proof (Aadhaar, PAN, Passport, or any Govt. ID)",
                "Hospital Discharge Summary (with treatment details)",
                "Doctor’s prescription (for hospitalization & medicines)",
                "Medical bills & receipts, etc.",
              ],
            },
          }),
        );
      } else if (subIntent === "Life") {
        messages.push(
          createChatBotMessage(
            "For a life insurance policy claim, the required documents depend on whether it is a death claim or a maturity claim.",
            {
              widget: "documentsWidget",
              payload: {
                title: "Life Insurance Claim Documents",
                categories: [
                  {
                    title: "Death Claim Documents",
                    documents: [
                      "Duly filled claim form (provided by the insurer)",
                      "Original policy document",
                      "Death certificate (issued by municipal authorities)",
                      "ID proof of nominee (Aadhaar, PAN, Passport, etc.)",
                      "Bank account details of nominee (for fund transfer)",
                    ],
                  },
                  {
                    title: "Maturity Claim Documents",
                    documents: [
                      "Original policy document",
                      "Duly filled maturity claim form",
                      "ID & Address proof",
                      "Bank details (cancelled cheque or passbook copy)",
                      "NEFT mandate form (for direct payment)",
                    ],
                  },
                ],
              },
            },
          ),
        );
      }

      // Show Claim Options Widget instead of Contact Widget
      // messages.push(
      //   createChatBotMessage(
      //     "For claim-related queries, you can reach us through:",
      //     {
      //       widget: "claimOptionsWidget",
      //     },
      //   ),
      // );
    }

    setState((prev) => ({
      ...prev,
      messages: [...prev.messages, ...messages],
    }));
  };

  return (
    <div>
      {React.Children.map(children, (child) => {
        return React.cloneElement(child, {
          actions: {
            handleGreeting,
            handleBotResponse,
            handleIntentSelection,
            handleSubIntentSelection,
            handleGoToMenu,
            handleSuggestedQuestionClick,
          },
        });
      })}
    </div>
  );
};

export default ActionProvider;
